import request from "@/utils/request";

// 登录
export function login(params) {
  return request({
    url: "/api/cross-paas/login",
    method: "get",
    params
  });
}

// 登录是否校验验证码
export function checkCaptcha(params) {
  return request({
    url: "/api/cross-paas/check-captcha",
    method: "get",
    params
  });
}


export function logout() {
  return request({
    url: "/api/cross-paas/logout",
    method: "get"
  });
}

// 获取验证码
export function flat(params) {
  return request({
    url: "/api/captcha/flat?" + params,
    method: "get",
    responseType:"blob"
  });
}
//shouyin
export function permissions(store_id) {
    return request({
        url: '/api/cross-paas/cashier/permissions',
        method: 'get',
        params: { store_id }
    });
}
//shouyin
export function checklogin() {
    return request({
        url: 'api/cross-paas/check-login-status',
        method: 'get',
        
    });
}